import React from 'react';
import { FaUsers } from 'react-icons/fa';
import DataAnalytics from '../../assets/images/1414907_IconsforPlatformFeatures5_DataAnalytics_072122.png';
import DataEntry from '../../assets/images/1391238_DataEntry-green_061722.png';
import Accountability from '../../assets/images/1409153_IconsforPlatformFeatures4_Accountability_071422.png';
import { Link } from 'react-router-dom';
import Footer from '../../components/footer';

const PatientHome = () => {
    return (  
        <>
            <div className="container-fluid py-4 h-100">
                <div className="card border-0 h-100">
                    <div className="card-body">
                        <h5 className='font-weight-lighter mt-2 mb-4'>Patient: Patient Home Page</h5>
                        <hr />
                        <h5 className='font-weight-lighter mt-4 mb-2'>Welcome, First</h5>
                        <div className="row mt-4">
                            <div className="col-md-3 pt-2">
                                <div className="text-center pl-md-5">
                                    <i className='fa fa-user-circle-o' style={{fontSize: 95}} />
                                </div>
                                <div className="col-md-10 offset-md-2 mt-4 shadow rounded_lg py-3 pr-3">
                                    <div className="media align-items-center ml-3">
                                        <h6 className='my-0 p-0'>Collaborators</h6>
                                        <div className="media-body pr-2 pl-2">
                                            <FaUsers size={22} />
                                        </div>
                                    </div>
                                    <div className="row align-items-center py-2">
                                        <div className="col-md-6 offset-md-1">
                                            <div className="d-flex align-items-center justify-content-between">
                                                <div>
                                                    <p className='p-0 m-0'><small className='f-10'>Healthcare</small></p>
                                                    <p className='p-0 m-0'><small className='f-10'>Providers</small></p>
                                                </div>
                                                <span className='small-text'>7</span>
                                            </div>
                                            <div className="d-flex align-items-center justify-content-between mt-2">
                                                <div>
                                                    <small className='f-10'>Family</small>
                                                </div>
                                                <span className='small-text'>2</span>
                                            </div>
                                        </div>
                                        <div className="col-md-5">
                                            <a href="#" data-toggle="modal" data-target="#filterModal" className='border_success rounded px-4'><i className='fa fa-chevron-right' /></a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-6 offset-md-3">
                                <h5 className="text-center decoration-0 mb-3">
                                    Tasks Available
                                </h5>
                                <div className="col-md-10">
                                    <div className="media align-items-center my-4">
                                        <img src={DataEntry} className="img-fluid" width={60} alt="" />
                                        <div className="media-body ml-4">
                                            <Link to={`/patient/enter_function`} className='btn btn-block btn-primary py-2'>
                                                Enter Functional Score
                                            </Link>
                                        </div>
                                    </div>
                                    <div className="media align-items-center my-4">
                                        <img src={DataAnalytics} className="img-fluid" width={60} alt="" />
                                        <div className="media-body ml-4">
                                            <Link to={`/patient/enter_function`} className='btn btn-block btn-primary py-2'>
                                                View Functional Scores
                                            </Link>
                                        </div>
                                    </div>
                                    <div className="media align-items-center my-4">
                                        <img src={Accountability} className="img-fluid" width={60} alt="" />
                                        <div className="media-body ml-4">
                                            <Link to={`/patient/enter_function`} className='btn btn-block btn-primary py-2'>
                                                View Care Plan Summaries
                                            </Link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </>
    );
}
 
export default PatientHome;